import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import AnimatedNumber from "../../common/components/AnimatedNumber";
import { SPACING } from "../../common/constants/spacing";

export const SourceDetailsTab = ({ source }) => {
  const { t } = useTranslation("sources");
  const DetailRow = ({ label, value }) => (
    <Grid container spacing={2} sx={{ mt: 3, mb: SPACING.xs }}>
      <Grid size={{ xs: 12, sm: 4, md: 3 }}>
        <Typography variant="bodyMd" fontWeight={600}>
          {label}
        </Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 8, md: 9 }}>
        <Typography variant="bodyMd">{value}</Typography>
      </Grid>
    </Grid>
  );

  return (
    <Box sx={{ py: 2 }}>
      <DetailRow
        label={t("sourceDetails.platform")}
        value={source.platform || t("sourceDetails.unknown")}
      />

      <DetailRow
        label={t("sourceDetails.accountName")}
        value={source.account_name || t("sourceDetails.unknown")}
      />

      <DetailRow
        label={t("sourceDetails.assets")}
        value={source.imported_video_count || "0"}
      />

      <DetailRow
        label={t("sourceDetails.totalImpressions")}
        value={
          <AnimatedNumber
            section="sourceDetails"
            value={source.total_impressions}
          />
        }
      />

      <DetailRow
        label={t("sourceDetails.followers")}
        value={
          <AnimatedNumber
            section="sourceDetails"
            value={source.follower_count}
          />
        }
      />

      <DetailRow
        label={t("sourceDetails.likes")}
        value={
          <AnimatedNumber section="sourceDetails" value={source.likes_count} />
        }
      />

      <DetailRow
        label={t("sourceDetails.createdOn")}
        value={new Date(source.created_at).toLocaleString()}
      />

      <DetailRow
        label={t("sourceDetails.lastFetchedAt")}
        value={
          source.last_fetched_at
            ? new Date(source.last_fetched_at).toLocaleString()
            : t("sourceDetails.never")
        }
      />

      <DetailRow
        label={t("sourceDetails.fetchFrequency")}
        value={`24 ${t("sourceDetails.hours")}`}
      />

      <DetailRow
        label={t("sourceDetails.status")}
        value={
          <Box
            component="span"
            sx={{
              textTransform: "capitalize",
              color:
                source.status === "active" ? "success.main" : "warning.main",
            }}
          >
            {source.status || "active"}
          </Box>
        }
      />
    </Box>
  );
};
